import { TrackingCache } from './../../../tracking/TrackingCache';
import { BasicCommand } from "./BasicCommand";
/**
 * Created by tschenkel on 8/20/2014.
 */


import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import {CoreErrorIdConstants} from "@goodgamestudios/shared-constants";

import {BasicErrorConstants} from "./constants/BasicErrorConstants";
import { error } from '../../../logging/error';


export class GPICommand extends BasicCommand {
		/*final*/ protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_GET_PLAYER_INFO;
    }

		/*final*/ public executeCommand(errorID: number, params: any[]): boolean {
        if (errorID == BasicErrorConstants.ALL_OK) {
            let paramsObj: Object = JSON.parse(params.pop());
            let networkId: number = paramsObj["networkId"];
            // Update the networkId for future tracking commands
            TrackingCache.getInstance().networkId = networkId;
            return true;
        }
        error("GPICommand received error: " + errorID.toString() + " while expecting to get errorId 0");
        return false;
    }
}

